export enum ApiErrorCode {
	INSUFFICIENT_PERMISSIONS = 'insufficient-permissions',
}
